import React from "react"
import { Typography } from "antd"
import Img from "gatsby-image"
import { Link } from "gatsby"

const FeaturedWork = ({ data }) => {
  const { Title } = Typography
  return (
    <>
      <div className="reviews-wrapper">
        <div className="reviews-grid">
          <div className="reviews-description">
            <Title level={2} className="case_study_class">Case Study</Title>
            <Title level={3}>
              AI Chatbot & Voice Agent for Big Jerry's Fencing
            </Title>
            <p>
              Big Jerry's Fencing needed a way to capture and qualify leads around the clock — without adding headcount. We built and deployed an AI chatbot live on their website that handles enquiries, collects project details, and books estimate appointments automatically.
               </p>
            <span className="view-case-study">
              <Link>Explore More</Link>
            </span>
          </div>
          <div className="reviews-cover">
            <Img fluid={data.BigJerry?.childImageSharp.fluid} />
          </div>
        </div>
      </div>
    </>
  )
}

export default FeaturedWork
